<button class="btn {{btnClass}}" [type]="type" [disabled]="loading" [ngClass]="{loading: loading}">
  <div class="btn-spinner float-left" *ngIf="loading"></div>
  <ng-content *ngIf="!loading"></ng-content>
  <span *ngIf="loading">{{loadingText}}</span>
</button>